import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useScrollArrows } from 'site-modules/shared/hooks/use-scroll-arrows';
import { MarkdownImage } from 'site-modules/canvas/components/chat-messages/ai-message/markdown/markdown-image/markdown-image';

import './markdown-photos-carousel.scss';

const ARROW_CLASS_NAME =
  'arrow pos-a center-y d-flex align-items-center justify-content-center bg-cool-gray-20 text-white mx-0_5';

export function MarkdownPhotosCarousel({ children, className = '', elementRef }) {
  const carouselRef = useRef();
  const [arrows, scrollLeft, scrollRight] = useScrollArrows(carouselRef);
  const displayChildren = React.Children.toArray(children);

  if (displayChildren?.length === 1) {
    return (
      <MarkdownImage
        key={displayChildren?.[0]?.props?.src}
        {...displayChildren?.[0]?.props}
        elementRef={elementRef}
        className={classnames('mb-1', className)}
      />
    );
  }

  return (
    <div ref={elementRef} className={classnames('markdown-photos-carousel pos-r', className)}>
      <button
        className={classnames(ARROW_CLASS_NAME, 'left left-0', {
          invisible: !arrows.left,
        })}
        onClick={scrollLeft}
        aria-label="Scroll photos left"
      >
        <i className="icon-arrow-left3" aria-hidden />
      </button>
      <ul ref={carouselRef} className="photos-list d-flex flex-nowrap gap-0_75 list-unstyled">
        {displayChildren.map(({ props: imageProps }) => {
          const { src } = imageProps;

          return <MarkdownImage key={src} {...imageProps} className="flex-shrink-0 mb-0" tag="li" />;
        })}
      </ul>
      <button
        className={classnames(ARROW_CLASS_NAME, 'right right-0', {
          invisible: !arrows.right,
        })}
        onClick={scrollRight}
        aria-label="Scroll photos right"
      >
        <i className="icon-arrow-right3" aria-hidden />
      </button>
    </div>
  );
}

MarkdownPhotosCarousel.displayName = 'MarkdownPhotosCarousel';

MarkdownPhotosCarousel.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
  elementRef: PropTypes.shape({}),
};
